// function to calculate the subtotal discount
// type: 1 = nominal, 2 = percentage

const calculateUnpayedAmount = (sales) => {
  if (!sales || !sales.data_sales_payments) return 0;

  const totalPayed = sales.data_sales_payments.reduce(
    (total, payment) => total + payment.amount,
    0
  );
  
  // var totalDiscount = 0;

  // sales.data_sales_discounts.forEach((discount) => {
  //   totalDiscount += discount.total;
  // });

  // console.log("GRAND TOTAL", sales.grand_total);
  // console.log("TOTAL PAYED", totalPayed);
  // console.log("TOTAL DISCOUNT", totalDiscount);

  // return sales.grand_total - totalPayed - totalDiscount;
  return sales.grand_total - totalPayed;
};
export default calculateUnpayedAmount;
